import { API_URL } from "./environments/urls";

export const urlBase = API_URL;

export function getApiKey() {
  return "Bearer " + localStorage.getItem("apiSesionId");
}

function login(user, password) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user: user, password: password }),
  };

  return fetch(urlBase + "/api/Login", requestOptions);
}

function getAllRaffles() {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
  };

  return fetch(urlBase + "/api/Raffle", requestOptions);
}

function getRaffle(id) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
  };

  if (!id) return fetch(urlBase + "/api/Raffle", requestOptions);

  return fetch(urlBase + "/api/Raffle/" + id, requestOptions);
}

function uploadFile(data) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: getApiKey(),
      "Content-Type": "multipart/form-data",
    },
    body: data,
  };

  return fetch(urlBase + "/api/File/", requestOptions);
}

function processRaffle(id) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({ Id: id }),
  };

  return fetch(urlBase + "/api/ProcessRaffle", requestOptions);
}

function resetRaffle(id) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({ Id: id }),
  };

  return fetch(urlBase + "/api/ResetRaffle", requestOptions);
}

function createRaffle(name, winners, participants, bench, fileId) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({
      Name: name,
      WinnerNumber: winners,
      ParticipantNumber: participants,
      BenchNumber: bench,
      FileId: fileId,
    }),
  };

  return fetch(urlBase + "/api/Raffle", requestOptions);
}

function createForm(
  raffleId,
  title,
  description,
  imageFile,
  expiresIn,
  requiresAttachment,
  attachmentLabel,
  additionalField1,
  additionalField2,
  additionalField3,
  additionalField1Values,
  additionalField2Values,
  additionalField3Values
) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({
      RaffleId: raffleId,
      Title: title,
      Description: description,
      ImageFile: imageFile,
      ExpiresIn: expiresIn,
      AdditionalField1: additionalField1,
      AdditionalField2: additionalField2,
      AdditionalField3: additionalField3,
      AdditionalField1Values: additionalField1Values,
      AdditionalField2Values: additionalField2Values,
      AdditionalField3Values: additionalField3Values,
    }),
  };

  return fetch(urlBase + "/api/RaffleForm", requestOptions);
}

function editForm(
  id,
  title,
  description,
  imageFile,
  expiresIn,
  requiresAttachment,
  attachmentLabel,
  additionalField1,
  additionalField2,
  additionalField3,
  additionalField1Values,
  additionalField2Values,
  additionalField3Values
) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({
      Id: id,
      Title: title,
      Description: description,
      ImageFile: imageFile,
      ExpiresIn: expiresIn,
      RequiresAttachment: requiresAttachment,
      AttachmentLabel: attachmentLabel,
      AdditionalField1: additionalField1,
      AdditionalField2: additionalField2,
      AdditionalField3: additionalField3,
      AdditionalField1Values: additionalField1Values,
      AdditionalField2Values: additionalField2Values,
      AdditionalField3Values: additionalField3Values,
    }),
  };

  return fetch(urlBase + "/api/RaffleForm", requestOptions);
}

function getForm(id) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: getApiKey(),
    },
  };

  if (!id) return fetch(urlBase + "/api/RaffleForm", requestOptions);

  return fetch(urlBase + "/api/RaffleForm/" + id, requestOptions);
}

function getCustomerForm(token) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {},
  };

  return fetch(urlBase + "/api/CustomerForm?token=" + token, requestOptions);
}

function submitCustomerForm(
  formId,
  raffleId,
  name,
  surname,
  email,
  phone,
  nationalId,
  addressName,
  addressNumber,
  addressOther,
  addressPostalCode,
  addressCity,
  addressProvince,
  file,
  additionalField1,
  additionalField2,
  additionalField3
) {
  const request = JSON.stringify({
    FormId: formId,
    RaffleId: raffleId,
    Name: name,
    Surname: surname,
    Email: email,
    Phone: phone,
    NationalId: nationalId,
    AddressName: addressName,
    AddressNumber: addressNumber,
    AddressOther: addressOther,
    AddressPostalCode: addressPostalCode,
    AddressCity: addressCity,
    AddressProvince: addressProvince,
    AdditionalField1: additionalField1,
    AdditionalField2: additionalField2,
    AdditionalField3: additionalField3,
  });

  const formData = new FormData();
  formData.append("data", request); // parte JSON
  if (file) {
    formData.append("attachment", file, file.name); // parte archivo
  }

  const requestOptions = {
    method: "POST",
    mode: "cors",
    body: formData,
  };

  return fetch(urlBase + "/api/CustomerForm", requestOptions);
}

function getUser(id) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
  };

  if (!id) return fetch(urlBase + "/api/User", requestOptions);

  return fetch(urlBase + "/api/User/" + id, requestOptions);
}

function getAccount(id) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
  };

  if (!id) return fetch(urlBase + "/api/Account", requestOptions);

  return fetch(urlBase + "/api/Account/" + id, requestOptions);
}

function getAllUsers() {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
  };

  return fetch(urlBase + "/api/Users", requestOptions);
}

function getFileAnalysis(fileid) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
  };

  return fetch(urlBase + "/api/FileAnalyzer/" + fileid, requestOptions);
}

function getFile(fileid) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: getApiKey(),
    },
  };

  if (!fileid) return fetch(urlBase + "/api/File", requestOptions);
  return fetch(urlBase + "/api/File/" + fileid, requestOptions);
}

function getRaffleResultFile(raffleid, file) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: getApiKey(),
    },
  };
  return fetch(
    urlBase + "/api/RaffleFileResult?id=" + raffleid + "&file=" + file,
    requestOptions
  );
}

function getFormRegistriesFile(formId) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: getApiKey(),
    },
  };

  if (!formId) return fetch(urlBase + "/api/FormRegistries", requestOptions);

  return fetch(
    urlBase + "/api/FormRegistries/" + formId + "/csv",
    requestOptions
  );
}

function getFormRegistries(formId) {
  const requestOptions = {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: getApiKey(),
    },
  };
  if (!formId) return fetch(urlBase + "/api/FormRegistries", requestOptions);
  return fetch(
    urlBase + "/api/FormRegistries/" + formId + "/raw",
    requestOptions
  );
}

function signup(userid, email, password, name, surname) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({
      UserId: userid,
      Email: email,
      Password: password,
      Name: name,
      Surname: surname,
    }),
  };
  return fetch(urlBase + "/api/Signup", requestOptions);
}

function postUser(accountId, name, surname) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({
      AccountId: accountId,
      Name: name,
      Surname: surname,
    }),
  };
  return fetch(urlBase + "/api/User", requestOptions);
}

function postAccount(accountId, userId, email, password) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: getApiKey(),
    },
    body: JSON.stringify({
      AccountId: accountId,
      UserId: userId,
      Email: email,
      Password: password,
    }),
  };
  return fetch(urlBase + "/api/Account", requestOptions);
}

const API = {
  Login: login,
  GetAllRaffles: getAllRaffles,
  GetRaffle: getRaffle,
  ProcessRaffle: processRaffle,
  ResetRaffle: resetRaffle,
  CreateRaffle: createRaffle,
  GetUser: getUser,
  PostUser: postUser,
  GetAccount: getAccount,
  PostAccount: postAccount,
  GetAllUsers: getAllUsers,
  UploadFile: uploadFile,
  GetFileAnalysis: getFileAnalysis,
  GetFile: getFile,
  GetRaffleResultFile: getRaffleResultFile,
  GetFormRegistriesFile: getFormRegistriesFile,
  GetFormRegistries: getFormRegistries,
  Signup: signup,
  CreateForm: createForm,
  EditForm: editForm,
  GetForm: getForm,
  GetCustomerForm: getCustomerForm,
  SubmitCustomerForm: submitCustomerForm,
};

export { API };
